"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyInstance = void 0;
const observers_1 = require("./observers");
/**
 * Manages a single property of a subject.
 *
 * Responsible for applying the property descriptors to an instance of a
 * subject, and for the property's observers.
 *
 * Owned by a {@link SubjectInstance}.
 */
class PropertyInstance {
    constructor(subject, { key, descriptor }, instance) {
        var _a;
        this.subject = subject;
        this.key = key;
        this.observers = new observers_1.Observers(this.name);
        if (descriptor) {
            const originalSetter = (_a = descriptor.set) === null || _a === void 0 ? void 0 : _a.bind(instance);
            Object.defineProperty(instance, key, Object.assign(Object.assign({}, descriptor), { set: originalSetter ? nextValue => {
                    originalSetter(nextValue);
                    this.notify();
                } : undefined }));
        }
        else {
            let value = instance[key];
            Object.defineProperty(instance, key, {
                get: () => value,
                set: nextValue => {
                    value = nextValue;
                    this.notify();
                },
            });
        }
    }
    /**
     * Notify the property's observers, and any observers of the entire subject
     * to which this property belongs.
     */
    notify() {
        this.observers.notify();
        this.subject.notify();
    }
    /**
     * Add an observer to the property.
     */
    observe(callback, options) {
        this.observers.add(callback, options);
    }
    /**
     * Remove an observer from the property.
     */
    unobserve(callback) {
        this.observers.remove(callback);
    }
    /**
     * The full name of this property, including its owning subject's name.
     *
     * @example "Foo.bar"
     */
    get name() {
        return this.subject.name + '.' + String(this.key);
    }
}
exports.PropertyInstance = PropertyInstance;
//# sourceMappingURL=property-instance.js.map